export const menuItems = [
    {
        label: "Dashboard",
        icon: "mdi mdi-apps",
        link: "/"
    },
    {
        label: "POS",
        icon: "mdi mdi-food",
        link: "/myvisitors"
    },
    {
        label: "Kitchen Board",
        icon: "mdi mdi-timer-sand",
        subItems: [
            {
                label: "Foods",
                link: "/visits",
            },
            {
                label: "Drinks",
                link: "/visitors",
            },
        ]
    },
    {
        label: "Orders/Bills",
        icon: "bx-money",
        link: "/myvisitors"
    },
    {
        label: "Inventory",
        icon: "mdi mdi-shopping",
        subItems: [
            {
                label: "Stock levels",
                link: "/stocklevels",
            },
            {
                label: "Add New Stock",
                link: "/addstock",
            },
            {
                label: "Product Items",
                link: "/productitems",
            },
            {
                label: "Product Item Units",
                link: "/productitemunits",
            },
            {
                label: "Product Categories",
                link: "/productcategories",
            },
            {
                label: "Product Units",
                link: "/productunits",
            },
            {
                label: "Suppliers",
                link: "/suppliers",
            },
        ]
    },
    {
        label: "Expenses",
        icon: "mdi mdi-database",
        subItems: [
            {
                label: "Record Expense",
                link: "/recordexpense",
            },
            {
                label: "View Expenses",
                link: "/viewexpenses",
            },
            {
                label: "Expense Items",
                link: "/expenseitems",
            },
            {
                label: "Expense Categories",
                link: "/expensecategories",
            },
        ]
    },
    {
        label: "Reports",
        icon: "mdi mdi-clipboard-list",
        subItems: [
            {
                label: "Orders Report",
                link: "/visits",
            },
            {
                label: "Payments Report",
                link: "/visitors",
            },
            {
                label: "Purchases Reports",
                link: "/visits",
            },
            {
                label: "Expenses Reports",
                link: "/visits",
            },
            {
                label: "Monthy Analysis",
                link: "/visitors",
            },
            {
                label: "Income & Expenditure",
                link: "/visitors",
            },
        ]
    },
    {
        label: "Settings",
        icon: "mdi mdi-cog",
        subItems: [
            {
                label: "System Users",
                link: "/users",
            },
            {
                label: "System Roles",
                link: "/roles",
            },
            {
                label: "System Permissions",
                link: "/permissions",
            },
            {
                label: "Payment Methods",
                link: "/paymentoptions",
            },
            {
                label: "Company Profile",
                link: "/profile",
            },
        ]
    },
    {
        label: "Inventory",
        icon: "mdi mdi-store-edit",
        subItems: [
            {
                label: "Inventory Unit",
                link: "/inventoryuints",
            },
            {
                label: "View Expenses",
                link: "/viewexpenses",
            },
            {
                label: "Expense Items",
                link: "/expenseitems",
            },
            {
                label: "Inventory Item",
                link: "/inventoryitems",
            },
            {
                label: "Store",
                subItems: [
                    {
                        label: "Add ",
                        link: "/add-to-store",
                    },   
                    {
                        label: "View",
                        link: "/view-store",
                    }, 
                    {
                        label: "Loses",
                        link: "/store-loses",
                    },               
                   
                ]
            },
            {
                label: "Requisition",
                subItems: [
                    {
                        label: "Add ",
                        link: "/add-order",
                    },   
                    {
                        label: "View",
                        link: "/view-order",
                    }, 
                                  
                   
                ]
            },
        ]
    },
    {
        label: "School Requirements",
        icon: "mdi mdi-task",
        subItems: [
            {
                label: "Item",
                link: "/school-requirement",
            },
            {
                label: "Allocation",
                link: "/requirement-allocation",
            },
            {
                label: "Collection",
                link: "/requirement-collection",
            },
            {
                label: "View",
                link: "/view-requirement-collection",
            },
                     
        ]
    },
];